import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, ListOrdered, User, Shield, Plus, Trophy } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function BottomNav() {
  const { user } = useAuth();
  const loc = useLocation();
  if (!user) return null;
  // Hide on auth pages
  if (["/login", "/register"].includes(loc.pathname)) return null;

  const items = [
    { to: "/", label: "Início", icon: Home, testId: "nav-home" },
    { to: "/orders", label: "Pedidos", icon: ListOrdered, testId: "nav-orders" },
    { to: "/create", label: "Comprar", icon: Plus, testId: "nav-create", primary: true },
    { to: "/leaderboard", label: "Ranking", icon: Trophy, testId: "nav-leaderboard" },
    { to: "/profile", label: "Perfil", icon: User, testId: "nav-profile" },
  ];
  if (user.role === "admin") {
    items.push({ to: "/admin", label: "Admin", icon: Shield, testId: "nav-admin" });
  }

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 md:hidden backdrop-blur-xl bg-background/80 border-t border-border"
      data-testid="bottom-nav"
    >
      <div className="max-w-md mx-auto flex justify-around items-stretch h-16">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <NavLink
              key={it.to}
              to={it.to}
              data-testid={it.testId}
              className={({ isActive }) =>
                `flex-1 flex flex-col items-center justify-center gap-0.5 text-xs transition-colors ${
                  isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
                } ${it.primary ? "font-bold" : ""}`
              }
            >
              {it.primary ? (
                <span className="w-11 h-11 -mt-6 rounded-full bg-primary text-primary-foreground flex items-center justify-center shadow-lg shadow-primary/30">
                  <Icon size={22} strokeWidth={2.5} />
                </span>
              ) : (
                <Icon size={22} strokeWidth={2} />
              )}
              <span>{it.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
